import { useTheme } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import ThreadsLoader from '../../../../MessageCenterPage/ThreadsLoader';
import UnreadMessageNotificationIcon from '../../../../shared/components/chat/UnreadMessageNotificationIcon';
import ChevronRightIcon from '../../../../shared/components/icons/ChevronRight';
import useAdminApi from '../../../../shared/hooks/useAdminApi';

interface Props {
  portfolioId: number;
  selectedConversationId: number | null;
  selectConversationId: (conversationId: number) => void;
}

export default function ChatConversationList({ portfolioId, selectConversationId, selectedConversationId }: Props) {
  const theme = useTheme();
  const api = useAdminApi();

  const { data, isInitialLoading } = useQuery(
    ['fetchChatConversationList', portfolioId],
    () => api.portfolios.fetchChatConversationList(portfolioId as number),
    {
      enabled: Boolean(portfolioId),
      refetchInterval: 10000,
    },
  );

  if (isInitialLoading) {
    return <ThreadsLoader />;
  }

  return (
    <div>
      {data?.map((item) => {
        const isSelected = selectedConversationId === item.conversationId;
        return (
          <div
            key={item.conversationId}
            onClick={() => {
              selectConversationId(item.conversationId);
            }}
            style={{
              height: 50,
              backgroundColor: isSelected ? theme.palette.backgroundColor.main : 'white',
              paddingLeft: 20,
              paddingRight: 20,
              paddingTop: 10,
              paddingBottom: 10,
              borderBottom: '1px solid #F1F1F1',
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              flex: 1,
              justifyContent: 'space-between',
            }}
          >
            <span
              style={{
                fontSize: '12px',
                fontWeight: isSelected ? 'bold' : 'normal',
                color: isSelected ? '#303334' : '#5A676E',
              }}
            >
              {item.companyName}
            </span>
            <div>
              {isSelected ? <ChevronRightIcon /> : item.unreadMessageCount > 0 && <UnreadMessageNotificationIcon />}
            </div>
          </div>
        );
      })}
    </div>
  );
}
